const showSurprise = () => {

	let surpriseBlock = document.querySelector('.surprise .surprise-block'),
		header = document.querySelector('.header'),		
		logo = document.querySelector('.header .logo'),
		logoImg = document.querySelectorAll('.header .logo img'),
		lines = document.querySelectorAll('.header .fence .line'),
		surpriseImg = document.querySelector('body .surprise-img'),
		selected = document.querySelectorAll('.selected'),	

		mainURL_EN = document.location.protocol + '//' + document.location.host + '/',
		mainURL_RU = document.location.protocol + '//' + document.location.host + '/ru';

	if(surpriseBlock) {
		surpriseBlock.addEventListener('mouseover', (e) => {

			surpriseImg.classList.remove('hide');
			header.style.backgroundColor = 'transparent';
			header.style.color = '#999999';

			lines.forEach(function(item, index, array) {

				item.style.backgroundColor = '#999999';

			});			

			selected.forEach(function(item, index, array) {					
				item.classList.add('selected-page-site');
			});

			logoImg[0].style.display = 'block';


			if (document.location.href == mainURL_EN) {
				logoImg[1].src = '/img/logo-white.png';
				
			} else if (document.location.href == mainURL_RU) {
				logoImg[1].src = '/img/ru_logo-white.png';				
			}


		});
		setTimeout(function hideSurprise() {

			surpriseImg.classList.add('hide');
			surpriseImg.classList.add('fadeIn');

			header.style.backgroundColor = '#fff';
			header.style.color = '#2d2d2d';

			lines.forEach(function(item, index, array) {				
				item.style.backgroundColor = '#2d2d2d';
			});

			selected.forEach(function(item, index, array) {					
				item.classList.remove('selected-page-site');
			});

			logoImg[0].style.display = 'none';
			
			if (document.location.href == mainURL_EN ) {
				logoImg[1].src = '/img/logo.png';							
			} else {
				logoImg[1].src = '/img/ru_logo.png';							
			}
			setTimeout(hideSurprise, 1000);

		});
	}		
}
export default showSurprise;